export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'dd3ea00c-6780-479a-bd2f-f9c918bccd3e';
export const MODAL_CLOSE_SEC = 2.5;
